// blogs.js
export const properties = [
  {
    id: 1,
    imageUrl: "/img/property/1.jpg",
    price: "N/A",
    name: "Movin Building and Apartment",
    description: "96 Apartments, Long and Short-Term Family Rooms",
    location: "Al Jadeed Bus Station",
    link: "/properties/property-details/1",

    // 🔽 additional data (new – safe to use later)
    fullAddress: "124 Omar Bin Al Khattab Street, Frij Al Murar, Dubai, UAE",
    roomTypes: "Studios",
    roomDetails: {
      studio: 94,
      oneBHK: 0,
      twoBHK: 0,
      threeBHK: 0,
    },
    totalUnits: 94,
    buildingStructure: "G+3+Roof",
    amenities: [],
    gallery: [],
    mapLocation: "",
  },
  {
    id: 2,
    imageUrl: "/img/property/2.jpg",
    price: "N/A",
    name: "Shalimar Building and Apartment",
    description: "72 Apartments, Long and Short Term For Families",
    location: "Sheikh Al Latifa Mosque",
    link: "/properties/property-details/2",

    fullAddress: "45th Street, Frij Al Murar, Dubai, UAE",
    roomTypes: "Studios",
    roomDetails: {
      studio: 75,
      oneBHK: 0,
      twoBHK: 0,
      threeBHK: 0,
    },
    totalUnits: 75,
    buildingStructure: "G+7+Roof",
    amenities: [],
    gallery: [],
    mapLocation: "",
  },
  {
    id: 3,
    imageUrl: "/img/property/3.jpg",
    price: "N/A",
    name: "City Life Building and Apartment",
    description: "36 Apartments, Long and Short Term For Families",
    location: "Sheikh Al Latifa Mosque",
    link: "/properties/property-details/3",

    fullAddress: "",
    roomTypes: "",
    roomDetails: {
      studio: 0,
      oneBHK: 0,
      twoBHK: 0,
      threeBHK: 0,
    },
    totalUnits: 36,
    buildingStructure: "",
    amenities: [],
    gallery: [],
    mapLocation: "",
  },
  {
    id: 4,
    imageUrl: "/img/property/4.jpg",
    price: "N/A",
    name: "City Life Villa G+2+Parking",
    description: "8 Bedroom Apartment with Parking",
    location: "Talal Supermarket, Hor Al Anz",
    link: "/properties/property-details/4",

    fullAddress: "Hor Al Anz, Dubai, UAE",
    roomTypes: "Bedrooms",
    roomDetails: {
      studio: 0,
      oneBHK: 0,
      twoBHK: 0,
      threeBHK: 8,
    },
    totalUnits: 1,
    buildingStructure: "G+2+Parking",
    amenities: [],
    gallery: [],
    mapLocation: "",
  },
  {
    id: 5,
    imageUrl: "/img/property/5.jpg",
    price: "N/A",
    name: "City Life Villa G+2",
    description: "10 Bedroom Villa in Hor Al Anz",
    location: "Salauddin Metro Station",
    link: "/properties/property-details/5",

    fullAddress: "Hor Al Anz, Dubai, UAE",
    roomTypes: "Bedrooms",
    roomDetails: {
      studio: 0,
      oneBHK: 0,
      twoBHK: 0,
      threeBHK: 10,
    },
    totalUnits: 1,
    buildingStructure: "G+2",
    amenities: [],
    gallery: [],
    mapLocation: "",
  },
  {
    id: 6,
    imageUrl: "/img/property/6.jpg",
    price: "N/A",
    name: "City Life Villa G+1",
    description: "10 Bedroom Apartment in Hamriya",
    location: "Bangladesh Embassy",
    link: "/properties/property-details/6",

    fullAddress: "Hamriya, Dubai, UAE",
    roomTypes: "Bedrooms",
    roomDetails: {
      studio: 0,
      oneBHK: 0,
      twoBHK: 0,
      threeBHK: 10,
    },
    totalUnits: 1,
    buildingStructure: "G+1",
    amenities: [],
    gallery: [],
    mapLocation: "",
  },
  {
    id: 7,
    imageUrl: "/img/property/7.jpg",
    price: "N/A",
    name: "City Life Villa G+2+Parking",
    description: "8 Bedroom Apartment with Parking",
    location: "Talal Supermarket, Hor Al Anz",
    link: "/properties/property-details/7",

    fullAddress: "Hor Al Anz, Dubai, UAE",
    roomTypes: "Bedrooms",
    roomDetails: {
      studio: 0,
      oneBHK: 0,
      twoBHK: 0,
      threeBHK: 8,
    },
    totalUnits: 1,
    buildingStructure: "G+2+Parking",
    amenities: [],
    gallery: [],
    mapLocation: "",
  },
  {
    id: 8,
    imageUrl: "/img/property/8.jpg",
    price: "N/A",
    name: "Bayt al Raffa Building",
    description: "12 Bedroom Apartment in Bur Dubai",
    location: "Convex Hotel Burdubai",
    link: "/properties/property-details/8",

    fullAddress: "Rolla Street, Bur Dubai, UAE",
    roomTypes: "Studio, 1BHK, 2BHK, 3BHK",
    roomDetails: {
      studio: 3,
      oneBHK: 6,
      twoBHK: 2,
      threeBHK: 2,
    },
    totalUnits: 13,
    buildingStructure: "G+3+Roof",
    amenities: [],
    gallery: [],
    mapLocation: "",
  },
];
